import {Component_Create} from "./component-create";
import {TagDto} from "../../../models/tag-dto";
import {CompositionDto} from "../../../models/composition-dto";
import {CompositionComponentLinkerDto} from "../../../_models/_inventory/composition-component-linker-dto";

export class Composition_Create {
  id: string = "";
  name: string = "";

  components: Component_Create[] = [];
  tags: string[] = [];

  price: number = 0;
  special: boolean = false;

  validate(): string | undefined {
    if (this.name.isNullOrWhitespace()) return "Name darf nicht leer sein.";
    return undefined;
  }

  static from(dto: CompositionDto): Composition_Create {
    let model = new Composition_Create();

    // id so it is an upsert
    model.id = dto.id;
    model.name = dto.name;
    model.price = dto.price;
    model.special = dto.special;

    // map components
    model.components = dto.componentLinkers.map(c => {
      const linker = new CompositionComponentLinkerDto();
      Object.assign(linker, c);
      return Component_Create.from(linker)
    });

    return model;
  }

  get isEditing(): boolean {
    return !this.id.isNullOrWhitespace();
  }
}

export class CompositionBuilder {
  private model: Composition_Create = new Composition_Create();

  isChanged(id: string) {
    this.model.id = id;
    return this;
  }

  isSpecial(special: boolean) {
    this.model.special = special;
    return this;
  }

  setName(name: string) {
    this.model.name = name.trim();
    return this;
  }

  setPrice(price: number) {
    this.model.price = price;
    return this;
  }

  setTags(tags: TagDto[]) {
    this.model.tags = tags.map(t => t.id);
    return this;
  }

  build() {
    return this.model;
  }
}
